/**
 * @description Media Type as per MPX metadata.mediaType (contentType) field
 */
export enum MPXMediaType {
	AA_ORIGINAL = 'AA Original',
	CLIP = 'Clip',
	EMPTY = '',
	FULL_EPISODE = 'Full Episode',
	LIVE = 'Live',
	MOVIE = 'Movie',
	NULL = 'NULL',
	PROMO_FULL_EPISODE = 'Promo Full Episode',
	SEASONLESS = 'Seasonless',
	SHOW_PROMO = 'Show Promo',
	STANDALONE = 'Standalone',
	TRAILER = 'Trailer',
}